import { useCallback } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import { GET_THEME_COLLECTION_ITEMS } from '../queries/assetCollectionItemsQuery';
export function useAssetCollectionItems({
  appContext,
  collectionId
}) {
  const client = useDataFetchingClient();
  const fetchThemeCollectionItemIds = useCallback(() => {
    if (!collectionId) {
      return Promise.resolve([]);
    }
    return client.query({
      query: GET_THEME_COLLECTION_ITEMS,
      variables: {
        appContext,
        collectionId
      }
    }).then(({
      data
    }) => {
      return data.themeCollectionItems.offeringIds;
    });
  }, [appContext, client, collectionId]);
  return {
    fetchThemeCollectionItemIds
  };
}